import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PageListWrapper from 'shared/styles/components/PageList';
import TabView from 'shared/ui/tabs/TabView';
import { Tab, ShadowNav } from 'shared/styles/components/Tabs';
// import SubscriptionList from './subscriptionOrderList';
import OrderList from './orderList';
import { addNotification, setPageSize } from 'core/redux/ui/actions';
import { LEVELS, createNotification } from 'shared/utilities/notification';
import { ERROR_MESSAGES } from 'shared/constants/messages';
import { ENV_DEFAULT_OPTION, ENV_DEFAULT_OPTION_SUBSCRIPTION } from 'shared/constants/matrixOptions';
import { PAGINATION_DEFAULT_OPTION } from 'shared/constants/pagination';
import SubscriptionDeleteList from './subscriptionOrderDelete';
import { setSearchTextGlobal, setStackAccount, setStackSelection } from 'core/redux/subscriptions/actions';

const subscription = ({
  setInitialLoad,
  setFetchingDevice,
  isFetchingDevices,
  setStackSelection,
  selectedStack,
  setStackAccount,
  showNotification,
  selectedAccount,
  searchTextSubscription,
  setSearchTextGlobal,
}) => {
  const [initialPageLoad, setInitialPageLoad] = useState(false);

  // function for updating initial loader
  const resetInitialLoad = (state) => {
    setInitialPageLoad(state);
  };

  useEffect(() => {
    setStackSelection(ENV_DEFAULT_OPTION_SUBSCRIPTION);
    setStackAccount(ENV_DEFAULT_OPTION_SUBSCRIPTION);
  }, []);

  const dispatch = useDispatch();
  // reset page size on route change
  useEffect(() => {
    return () => {
      dispatch(setPageSize(PAGINATION_DEFAULT_OPTION));
      setStackSelection(null);
      setStackAccount(null);
      setSearchTextGlobal('');
    };
  }, []);

  return (
    <PageListWrapper>
      <TabView
        tabContainer={ShadowNav}
        tabs={[
          {
            tabElement: <Tab>Show Order</Tab>,
            content: (
              <OrderList
                key={(selectedAccount?.value || '') + (selectedStack?.value || '')}
                setFetchingDevices={setFetchingDevice}
                isFetchingDevices={isFetchingDevices}
                reloadComponent={(org) => reloadComponent(org)}
                selectedStack={selectedStack}
                selectedAccount={selectedAccount}
                stackSelection={setStackSelection}
                setStackAccount={setStackAccount}
                showNotification={showNotification}
                initialPageLoad={initialPageLoad}
                searchTextSubscription={searchTextSubscription}
                setSearchTextGlobal={setSearchTextGlobal}
              />
            ),
          },
          {
            tabElement: <Tab>Delete Order</Tab>,
            content: (
              <SubscriptionDeleteList
                key={selectedAccount?.value}
                initialPageLoad={initialPageLoad}
                setInitialLoads={(state) => setInitialPageLoad(state)}
                showNotification={showNotification}
                selectedAccount={selectedAccount}
                setStackAccount={setStackAccount}
                searchTextSubscription={searchTextSubscription}
                setSearchTextGlobal={setSearchTextGlobal}
              />
            ),
          },
        ]}
      />
    </PageListWrapper>
  );
};

export default connect(
  (state) => ({
    // isFetchingDevices: state.deviceOperations.isFetchingDevices,
    selectedStack: state.subscription.stackSelection,
    selectedAccount: state.subscription.selectedAccount,
    searchTextSubscription: state.subscription.searchTextSubscription,
  }),
  (dispatch) => ({
    // setFetchingDevice: (status) => dispatch(setFetchingDevices(status)),
    setSearchTextGlobal: (text) => dispatch(setSearchTextGlobal(text)),
    setStackSelection: (stack) => dispatch(setStackSelection(stack)),
    setStackAccount: (account) => dispatch(setStackAccount(account)),
    resetEnvStackOption: () => dispatch(resetEnvStackOptions()),
    showSwitchNotification: (type, message) =>
      dispatch(
        addNotification({
          notification: createNotification(type, message),
        })
      ),
    showNotification: (e, type) =>
      dispatch(
        addNotification({
          notification: createNotification(LEVELS.ERROR, ERROR_MESSAGES.FETCH_ORDERS),
        })
      ),
  })
)(subscription);
